import { createContext, useContext } from "react";

export type DictationTranscriber = (file: File, signal: AbortSignal) => Promise<{ text: string }>;
export const DictationContext = createContext<DictationTranscriber | null>(null);
export const useDictationTranscriber = () => useContext(DictationContext);
